module.exports = __webpack_public_path__ + "static/media/the-pirates.26f62f19.webp";